import clsx from 'clsx';

import { SDSText } from '@repo/sds/SDSText';

import './TextWithHighlightedSearch.scss';

interface TextWithHighlightedSearchProps {
  label: string;
  search: string;
}

export function TextWithHighlightedSearch({ label, search }: TextWithHighlightedSearchProps) {
  const classNameWithOverflow = clsx('TextWithHighlightedSearch', 'TextWithHighlightedSearch--overflow');

  if (!search) return <SDSText text={label} type="body-medium" className={classNameWithOverflow} />;

  const searchLower = search.toLowerCase();
  const labelLower = label.toLowerCase();
  const index = labelLower.indexOf(searchLower);

  if (index === -1) return <SDSText text={label} type="body-medium" className={classNameWithOverflow} />;

  return (
    <>
      <SDSText text={label.substring(0, index)} type="body-medium" className={classNameWithOverflow} />
      <SDSText
        text={label.substring(index, index + search.length)}
        type="body-medium-bold"
        className="TextWithHighlightedSearch"
      />
      <SDSText text={label.substring(index + search.length)} type="body-medium" className={classNameWithOverflow} />
    </>
  );
}
